"use client";

import { useMemo } from "react";
import {
  isValidProductSlug,
  PRODUCT_CONFIGS,
} from "@/lib/calculators/truck-loading-merged/product-presets";
import {
  reserveAddedLoads,
  type AddedLoad,
} from "@/lib/calculators/truck-loading-merged/reserve-added-items";
import {
  toNumber,
  type GeometryCategory,
  type TruckSpec,
} from "@/lib/calculators/truck-loading-merged/types";
import type { AdditionalItem } from "./additional-item-types";

function geometryOf(presetId: string): GeometryCategory {
  const [productSlug] = presetId.split("__");
  return productSlug && isValidProductSlug(productSlug)
    ? PRODUCT_CONFIGS[productSlug].defaultGeometry
    : "box";
}

function addedLoad(addedItem: AdditionalItem): AddedLoad {
  return {
    item: {
      lengthIn: Math.max(toNumber(addedItem.length), 0),
      widthIn: Math.max(toNumber(addedItem.width), 0),
      heightIn: Math.max(toNumber(addedItem.height), 0),
      weightLbs: Math.max(toNumber(addedItem.weight), 0),
      geometryCategory: geometryOf(addedItem.presetId),
      stackable: addedItem.stackable,
      palletized: false,
      palletHeightIn: 0,
    },
    quantity: Math.max(Math.round(toNumber(addedItem.quantity)), 0),
  };
}

export function useVirtualTruck(
  selectedTruck: TruckSpec,
  additionalItems: Array<AdditionalItem>,
): TruckSpec {
  return useMemo(
    () => reserveAddedLoads(selectedTruck, additionalItems.map(addedLoad)),
    [selectedTruck, additionalItems],
  );
}
